import React from "react";

import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";

import { store } from "@components/VerticalLayout/store";
import {
    store as saleMode,
    setGlobalDataIsUpdated,
    setIsLoading,
} from "../store";

import { capitalize } from "@helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../../api/hooks";
import ErrorToast from "@components/Common/ErrorTost";
import { showSuccessToast } from "@components/Common/SuccessToast";

type ConfirmationFavoriteType = {
    modalState: any;
    setModalState: Function;
    e: any;
    setDataIsUpdated: Function;
};

export function ConfirmationFavorite({
    modalState,
    setModalState,
    e,
    setDataIsUpdated,
}: ConfirmationFavoriteType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const { franchiseID, userID, operatorID } = useSnapshot(store);
    const { modeSaleData, shopsModeSaleData } = useSnapshot(saleMode);

    const [error, setError] = React.useState<boolean>(false);
    const uuidUser = localStorage.getItem("uuidUser");

    async function favoriteShopModeOfSale(isFavorite: boolean) {
        toast.dismiss();
        setIsLoading(true);
        let localData: any = [];

        shopsModeSaleData.data.forEach((shop: any) => {
            let objectData: any = {};
            modeSaleData.data.forEach((el: any) => {
                shop.subRows.forEach((modeOfSale: any) => {
                    if (e.Id === modeOfSale.Id) {
                        objectData[modeOfSale.Id] = {
                            tag: modeOfSale.tag,
                            display_name: modeOfSale.display_name,
                            support_vente: modeOfSale.support_vente,
                            isArchived: modeOfSale.isArchived,
                            state:
                                modeOfSale.state === true
                                    ? modeOfSale.state
                                    : isFavorite,
                            shopId: modeOfSale.shopId,
                            isFavorite: isFavorite,
                            designation: modeOfSale["Mode of sale"],
                            advancedDisplayName: modeOfSale.advancedDisplayName,
                        };
                    } else if (
                        el.Id === modeOfSale.Id &&
                        shop.subRows.findIndex(
                            (elt: any) => elt.Id === e.Id
                        ) !== -1 &&
                        modeOfSale.isFavorite === true
                    ) {
                        objectData[modeOfSale.Id] = {
                            tag: modeOfSale.tag,
                            display_name: modeOfSale.display_name,
                            support_vente: modeOfSale.support_vente,
                            isArchived: modeOfSale.isArchived,
                            state: modeOfSale.state,
                            shopId: modeOfSale.shopId,
                            isFavorite: false,
                            designation: modeOfSale["Mode of sale"],
                            advancedDisplayName: modeOfSale.advancedDisplayName,
                        };
                    }
                });
            });

            let dataModeOfSale = {
                userId: userID,
                shopId: [shop.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                isShop: false,
                isFavoring: true,
                isEmpty: false,
                data: objectData,
            };

            if (Object.keys(objectData).length > 0)
                localData.push(dataModeOfSale);
        });

        try {
            await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(localData),
                }
            );
        } catch (e) {
            ErrorToast(t("There's an error")!);
            setError(true);
        }

        if (error === false) {
            showSuccessToast(
                isFavorite
                    ? `${t(
                          "Shop favorite state has been successfully activated"
                      )}`
                    : `${t(
                          "Shop favorite state has been successfully deactivated"
                      )}`
            );
        }
        setDataIsUpdated(true);
        setGlobalDataIsUpdated(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }

    return (
        <StyledModal
            toggle={true}
            isOpen={modalState.isFavoriteModified!}
            centered
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setModalState((prev: any) => ({
                        ...prev,
                        isFavoriteModified: false,
                    }));
                    setDataIsUpdated(true);
                    setGlobalDataIsUpdated(true);
                }}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setModalState((prev: any) => ({
                            ...prev,
                            isFavoriteModified: false,
                        }));
                        setDataIsUpdated(true);
                        setGlobalDataIsUpdated(true);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        favoriteShopModeOfSale(!e.isFavorite);
                        setModalState((prev: any) => ({
                            ...prev,
                            isFavoriteModified: false,
                        }));
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
